import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { baseWhite, secondaryBase } from '../../styles/design-tokens';
import { Button } from '../../ui-library/button/button';
import { Icon } from '../../ui-library/icon/icon';
import { AgenticViewType } from './agentic-process.type';

interface AgenticProcessTabsProps {
  viewType: AgenticViewType;
  setViewType: (viewType: AgenticViewType) => void;
}

const iconMap: Record<AgenticViewType, string> = {
  [AgenticViewType.Tasks]: 'task',
  [AgenticViewType.Sessions]: 'group',
  [AgenticViewType.Financials]: 'payments',
};

export const AgenticProcessTabs = ({ viewType, setViewType }: AgenticProcessTabsProps) => {
  const { t } = useTranslation();

  const titles: Record<AgenticViewType, string> = {
    [AgenticViewType.Tasks]: t('common.work_units'),
    [AgenticViewType.Sessions]: 'Sessions',
    [AgenticViewType.Financials]: 'Financials',
  };

  return (
    <Group gap="xs">
      {[AgenticViewType.Tasks, AgenticViewType.Sessions, AgenticViewType.Financials].map((value) => (
        <Button
          size="xs"
          radius="xl"
          key={value}
          variant={value === viewType ? 'secondary' : 'outline'}
          onClick={() => setViewType(value)}
          leftSection={
            <Icon
              name={iconMap[value]}
              color={value === viewType ? baseWhite : secondaryBase}
              size={16}
              style={{ cursor: 'pointer' }}
            />
          }
        >
          {titles[value]}
        </Button>
      ))}
    </Group>
  );
};
